
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { StaffTable } from "@/components/staff/StaffTable";
import { DeleteStaffDialog } from "@/components/staff/DeleteStaffDialog";
import { ImportStaffDialog } from "@/components/staff/ImportStaffDialog";
import { useStaff } from "@/hooks/useStaff";
import { useEffect } from "react";

const Staff = () => {
  const {
    staff,
    loading,
    staffToDelete,
    setStaffToDelete,
    handleDelete,
    fetchStaff,
    searchQuery,
    handleSearchChange,
    page,
    pageSize,
    totalCount,
    handlePageChange,
  } = useStaff();

  // Add cleanup for ResizeObserver warning
  useEffect(() => {
    const reportError = (event: ErrorEvent) => {
      if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
        event.stopImmediatePropagation();
      }
    };

    window.addEventListener('error', reportError);
    return () => window.removeEventListener('error', reportError);
  }, []);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <div className="flex justify-between items-start">
                <div>
                  <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                    Staff
                  </h1>
                  <p className="text-xl text-gray-600 mt-2">
                    Manage staff accounts
                  </p>
                </div>
                <ImportStaffDialog onImportComplete={fetchStaff} />
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6">
              <StaffTable
                staff={staff}
                loading={loading}
                onDelete={setStaffToDelete}
                onStaffUpdated={fetchStaff}
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                page={page}
                pageSize={pageSize}
                totalCount={totalCount}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      <DeleteStaffDialog
        staff={staffToDelete}
        isOpen={!!staffToDelete}
        onClose={() => setStaffToDelete(null)}
        onConfirm={() => staffToDelete && handleDelete(staffToDelete)}
      />
    </SidebarProvider>
  );
};

export default Staff;
